import { Component, OnInit, inject } from '@angular/core';
import { Background } from '../../shared/components/background/background';
import { Connect } from '../../shared/components/connect/connect';
import { HeroSection } from '../../shared/components/hero-section/hero-section';
import { Button } from '../../shared/components/button/button';
import { Info } from '../../shared/components/info/info';
import { HealthcareCardNumberContainer } from './components/healthcare-card-number-container/healthcare-card-number-container';
import { HealthcareChooseUs } from './components/healthcare-choose-us/healthcare-choose-us';
import { HealthCareProcess } from './components/healthcare-process/healthcare-process';
import { CalendlyService } from '../../shared/services/calendly.service';
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-apps-healthcare-marketing',
  imports: [Background, HeroSection, HealthCareProcess, HealthcareChooseUs, Info, Button, HealthcareCardNumberContainer, Connect],
  templateUrl: './apps-healthcare-marketing.html',
  styleUrl: './apps-healthcare-marketing.scss'
})
export class AppsHealthcareMarketing implements OnInit {

  protected file = 'healthcare-marketing';

  private calendly = inject(CalendlyService);
  private seo = inject(SeoService);

  ngOnInit() {
    this.seo.apply({
      title: 'Healthcare App Marketing',
      description: 'SEM Nexus markets healthcare, telehealth, and wellness apps with compliant targeting, optimized creatives, and full-funnel acquisition strategies.',
      canonical: '/apps-healthcare-marketing/',
      image: 'https://semnexus.com/images/healthcare-marketing/backgrounds/healthcare-marketing.avif',
      imageAlt: 'Healthcare app marketing services by SEM Nexus',
      type: 'website',
    });
    this.seo.setBreadcrumbs([
      { name: 'Home', url: '/' },
      { name: 'Healthcare App Marketing' },
    ]);
    this.seo.setJsonLd('service', {
      '@context': 'https://schema.org',
      '@type': 'Service',
      '@id': 'https://semnexus.com/apps-healthcare-marketing/#service',
      name: 'Healthcare App Marketing',
      serviceType: 'HIPAA-aware app marketing for healthcare, telehealth, and wellness',
      description: 'Compliant targeting, optimized creatives, and full-funnel acquisition for healthcare, telehealth, and wellness apps.',
      provider: { '@id': 'https://semnexus.com/#organization' },
      areaServed: { '@type': 'Country', name: 'United States' },
      url: 'https://semnexus.com/apps-healthcare-marketing/',
    });
  }

  scheduleCall() {
    this.calendly.openPopup();
  }
}
